import React, { Component } from 'react';
import WelcomeHeader from '../header/WelcomeHeader';
import DisneyHero from '../disney-hero/DisneyHero';
import qr from '../images/qr.png';
import './Welcome.scss';

export default class Welcome extends Component {
  render() {
    const isToyStoryTheme = this.props.theme === 'disney' || this.props.theme === 'disney-toy-story-5';

    return (
      <div className={isToyStoryTheme ? 'welcome disney-screen' : 'welcome'}>
        {isToyStoryTheme &&
          <DisneyHero className="disney-screen__hero" showBrandRow={true} showCopy={false} />
        }

        <div className={isToyStoryTheme ? 'disney-screen__content disney-screen__content--welcome' : ''}>
          <WelcomeHeader theme={this.props.theme} welcomeMessage={this.props.welcomeMessage} />
          <span className='welcome__player-count'>{this.props.players}</span>
          <p className='mt-3'>Get your phones at the ready.</p>
          <p className='mb-3'>Get involved. Scan QR-code or register at chemistry.teamlewis.com</p>

          <img className='mt-2' src={qr} alt="chemistry.teamlewis.com" />

          <button className='btn btn-pink btn-action' disabled={this.props.disabled} onClick={this.props.onStart}>Start</button>
        </div>
      </div>
    );
  }
}